/* eslint-disable */
"use strict";

var config, service, messaggi;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  messaggi = config.VUE_APP_MOL_S_MESSAGES
}

async function inviaMessaggioSingolo(mittente, destinatari, messaggioDaInviare) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      mittente,
      destinatari,
      messaggioDaInviare,
    };
    const response = await fetch(
      `${service}/${messaggi}/whatsapp/invia/singolo`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function inviaMessaggioSmsSingolo(mittente, destinatario, messaggioDaInviare) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      mittente,
      destinatario,
      messaggioDaInviare
    }
    const response = await fetch(`${service}/${messaggi}/sms/invia/singolo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

export default {
  inviaMessaggioSingolo,
  inviaMessaggioSmsSingolo
};
